import { useLocalStorageState } from 'ahooks';
import { Theme } from 'emoji-picker-react';
import { EmojiClickData } from 'emoji-picker-react/dist/types/exposedTypes';
import { useEffect } from 'react';
import { useChatContext } from '../../../../../../Chat.hook.ts';
import { useMessageBarContext } from '../../../../MessageBar.hook.ts';
import {
  tEmojiActionHookProps,
  tEmojiActionProps,
} from './EmojiAction.types.ts';

const useEmojiAction = (props: tEmojiActionHookProps): tEmojiActionProps => {
  const { textAreaRef } = useChatContext();
  const { messageBarValue, setMessageBarValue } = useMessageBarContext();
  const { emojiButtonRef, showEmojiPicker, setShowEmojiPicker } = props;

  const [theme] = useLocalStorageState<string | undefined>('leadsales', {
    listenStorageChange: true,
  });

  const emojiPickerTheme = theme === 'leadsales' ? Theme.LIGHT : Theme.DARK;

  // Handle clicks outside the emoji picker
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      // Check if emoji picker is open
      if (!showEmojiPicker) return;

      // Get the emoji picker element from the DOM (the actual rendered element)
      const emojiPickerElement = document.querySelector('.EmojiPickerReact');

      // Check if click was outside both the emoji button and the emoji picker
      if (
        emojiButtonRef.current &&
        !emojiButtonRef.current.contains(event.target as Node) &&
        emojiPickerElement &&
        !emojiPickerElement.contains(event.target as Node)
      ) {
        setShowEmojiPicker(false);
      }
    };

    // Add event listener when emoji picker is shown
    document.addEventListener('mousedown', handleClickOutside);

    // Clean up the event listener when component unmounts or emoji picker is closed
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showEmojiPicker, emojiButtonRef, setShowEmojiPicker]);

  function addEmojiToMessage(emoji: EmojiClickData) {
    const emojiRef = textAreaRef;

    if (emojiRef.current) {
      const cursorPosition = emojiRef.current.selectionStart;

      const nextValue = `${messageBarValue.slice(0, cursorPosition)}${emoji.emoji}${messageBarValue.slice(cursorPosition)}`;
      setMessageBarValue(nextValue);
    }
  }

  return { emojiPickerTheme, addEmojiToMessage };
};

export default useEmojiAction;
